//商品発注書 新規作成画面
import React, { useEffect, useState, useCallback } from 'react';
import AppBarComponent from '../components/parts/appBar/AppBarComponent';
import { Button, Snackbar } from '@material-ui/core';
import LoadingComponent from '../components/LoadingComponent';
import MuiAlert, { AlertProps } from '@material-ui/lab/Alert';
import { useRecoilState, useRecoilValue } from 'recoil';
import { openErrorFlg, resMessage, isLoggedIn } from '../GlobalState';
import { useHistory, Redirect } from 'react-router-dom';
import { TLedger, TLedgerPictur } from '../types/Ledger';
import { Ledger } from '../components/ledger/Ledger';
import _ from 'lodash';
import { TFolderPicture } from '../types/cloudStorage/CloudFileList';
import { folderListState, selectedPicturesState } from '../GlobalState';
import { getFolderList } from '../apicalls/ledger';
import { useSnackbar } from 'notistack';
import { TPicture } from '../types/cloudStorage/CloudFileList';

type TSelect = { value: number; label: string; label_name_only: string };

export const CreateLedger: React.FC = () => {
  const history: any = useHistory();

  const constructId: TSelect = history.location.state.constructId;
  const ledgerListFlg: TSelect = history.location.state.ledgerListFlg
    ? history.location.state.ledgerListFlg
    : false;

  // リクエスト結果のメッセージ
  const { enqueueSnackbar } = useSnackbar();

  // 写真データ
  const imageData = useRecoilValue<TPicture[]>(selectedPicturesState);

  const [defaultValues, setDefaultValues] = useState<TLedger>();

  // エラーメッセージ表示フラグ
  const [open, setOpen] = useRecoilState(openErrorFlg);
  // ローディング表示フラグ
  const [loading, setLoading] = useState(false);
  // エラーメッセージ
  const [errorMessage, setErrorMessage] = useRecoilState(resMessage);
  const [loggedIn, setLoggedIn] = useRecoilState(isLoggedIn);

  const [, setFolderList] = useRecoilState<TFolderPicture[]>(folderListState);

  const changeLoggedInData = useCallback(
    (newData: string) => setLoggedIn(newData),
    [setLoggedIn]
  );

  const handleClose = (event?: React.SyntheticEvent, reason?: string) => {
    if (reason === 'clickaway') {
      return;
    }
    setOpen(false);
  };

  const Alert = (props: AlertProps) => {
    return <MuiAlert elevation={6} variant='filled' {...props} />;
  };

  useEffect(() => {
    setFolderList([]);
    getFolderList(constructId.value, enqueueSnackbar, setFolderList);
    setHookForm();
  }, []);

  const setHookForm = () => {
    const ledgerPictures: TLedgerPictur[] = [];

    for (let i = 0; imageData.length > i; i++) {
      const picture: TPicture = imageData[i];
      ledgerPictures.push({
        picture_id: picture.id,
        sort_order: 0,
        shooting_date: picture.shooting_date,
        place: '',
        note: picture.description
      });
    }
    const defaultValues: TLedger = {
      construct_id: constructId.value,
      construct_name: constructId.label_name_only,
      title: '',
      pictures: ledgerPictures
    };

    setDefaultValues(defaultValues);
  };

  if (loggedIn === 'Not logged in!') {
    return <Redirect to='/' />;
  }

  return (
    <div style={{ backgroundColor: '#F5F5F5' }}>
      <AppBarComponent
        patternName={ledgerListFlg ? 'create_ledger' : 'create_ledger_pictures'}
      />
      {loading ? (
        <>
          <Snackbar open={open} autoHideDuration={4000} onClose={handleClose}>
            <Alert onClose={handleClose} severity='error'>
              {errorMessage}
            </Alert>
          </Snackbar>
          <LoadingComponent />
        </>
      ) : (
        <>
          {defaultValues && (
            <Ledger
              defaultValues={defaultValues}
              changeLoggedInData={changeLoggedInData}
            />
          )}
        </>
      )}
    </div>
  );
};
